import createRequestSlice, { requestInitialState } from 'redux/request/reducer';

export const PREFIX = 'dashboard';

export const initialState = {
  ...requestInitialState,
  data: {},
  isLoading: false,
  hasError: false,
};

const dashboardSlice = createRequestSlice({
  name: PREFIX,
  initialState,
  reducers: {
    request(state) {
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    },
    failure(state) {
      return {
        ...state,
        isLoading: false,
        hasError: true,
      };
    },
    fetch(state, { payload }) {
      console.log('Datos recibidos en fetch:', payload);
      return {
        ...state,
        data: payload,
        isLoading: false,
        hasError: false,
      };
    },
    clear() {
      return { ...initialState };
    },
  },
});

export const actions = { ...dashboardSlice.actions };
export const requests = { ...dashboardSlice.requests };

export default dashboardSlice.reducer;
